export function PrivacyPolicyPage() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px', fontFamily: 'var(--font-family, system-ui, sans-serif)', color: 'var(--color-text, #1a1a1a)', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: 'var(--color-text-muted, #666)', fontSize: 14, marginBottom: 32 }}>
        Last updated: March 25, 2026
      </p>

      <p>
        Cade (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) is operated by Cade Security Ltd. This Privacy Policy
        describes how we collect, use, and protect information when you use the Cade platform,
        including the web application, browser extension, mobile app, and Slack integration
        (collectively, the &quot;Service&quot;).
      </p>

      <h2>1. Information We Collect</h2>

      <h3>Account &amp; Authentication</h3>
      <p>
        When you sign in via your organization&apos;s Microsoft Entra ID (Azure AD), we receive your
        name, email address, and organizational tenant identifier. We do not receive or store your
        Microsoft password.
      </p>

      <h3>Usage Data</h3>
      <p>
        We collect information about how you interact with the Service, including conversations with
        the AI assistant, queries, investigation actions, and feature usage. This data is scoped to
        your organization&apos;s tenant and is used to provide and improve the Service.
      </p>

      <h3>Security Tool Data</h3>
      <p>
        When you connect security tools (e.g., Microsoft Defender, Splunk, Okta) through our
        connector framework, we process data from those tools on your behalf to provide
        investigation and analysis capabilities. Connector credentials are encrypted at rest.
      </p>

      <h3>Browser Extension</h3>
      <p>
        The Cade browser extension may access the content of the active tab when you explicitly
        interact with it (e.g., selecting text for analysis). The extension does not passively
        monitor or collect browsing activity.
      </p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To provide, maintain, and improve the Service</li>
        <li>To authenticate users and enforce tenant-level access controls</li>
        <li>To process your security investigation queries and return AI-generated analysis</li>
        <li>To maintain audit logs for your organization&apos;s compliance requirements</li>
        <li>To deliver notifications and messages via connected channels (e.g., Slack)</li>
      </ul>

      <h2>3. Data Isolation &amp; Multi-Tenancy</h2>
      <p>
        Cade is a multi-tenant platform with strict data isolation. Each organization&apos;s data is
        logically separated at the database level using row-level security. Users from one
        organization cannot access data belonging to another organization.
      </p>

      <h2>4. Data Retention</h2>
      <p>
        Conversation data and investigation history are retained for as long as your organization
        maintains an active account. Session tokens expire after 24 hours. Your organization&apos;s
        administrator can request deletion of all tenant data by contacting us.
      </p>

      <h2>5. Third-Party Services</h2>
      <p>
        The Service uses third-party AI models to power its analysis capabilities. Queries sent to
        AI providers are processed in accordance with our data processing agreements and are not
        used to train third-party models. We use cloud infrastructure providers (AWS) to host the
        Service.
      </p>

      <h2>6. Security</h2>
      <p>
        We implement industry-standard security measures, including encryption in transit (TLS),
        encryption at rest for sensitive data, role-based access controls, and comprehensive audit
        logging. Connector credentials and API keys are stored using encrypted storage.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have the right to access, correct, delete, or
        export your personal data. Organization administrators can manage users and data through the
        Cade settings panel. For individual requests, contact us at the address below.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify users of material
        changes by posting the updated policy on this page with a revised &quot;Last updated&quot; date.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy or our data practices, please contact us
        at: <a href="mailto:privacy@getcade.ai">privacy@getcade.ai</a>
      </p>
    </div>
  );
}
